/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_ViewInputs */

const en_settings_billing_view = /** @type {(inputs: Settings_Billing_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const zh_settings_billing_view = /** @type {(inputs: Settings_Billing_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看订阅`)
};

/**
* | output |
* | --- |
* | "View" |
*
* @param {Settings_Billing_ViewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_view = /** @type {((inputs?: Settings_Billing_ViewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_ViewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_view(inputs)
	return zh_settings_billing_view(inputs)
});
export { settings_billing_view as "settings.billing.view" }